import { z } from "zod"

export const parseValidItems = <T>(schema: z.ZodType<T>, data: unknown[]): T[] => {
    return data.reduce<T[]>((acc, item) => {
        const result = schema.safeParse(item)
        if (result.success) {
            acc.push(result.data)
        } else {
            console.error("Invalid item filtered out:", result.error.message)
        }
        return acc
    }, [])
}

export const uuidSchema = z.uuid()
export const userIdSchema = z.guid()
export const latitudeSchema = z.number().min(-90).max(90)
export const longitudeSchema = z.number().min(-180).max(180)

export const locationSchema = z.object({
    zoom: z.number().optional(),
    latitude: latitudeSchema.optional(),
    longitude: longitudeSchema.optional(),
})

export const parseValidItem = <T>(schema: z.ZodType<T>, data: unknown): T | null => {
    if (!data) return null
    const result = schema.safeParse(data)
    if (!result.success) {
        console.error("Invalid item filtered out:", result.error.message)
        return null
    }
    return result.data
}

export const isValidEmail = (value: string) => z.email().safeParse(value).success

export const parseJsonWith = <T extends z.ZodType>(schema: T, raw: string) => {
    try {
        const parsed = schema.safeParse(JSON.parse(raw))
        return parsed.success ? parsed.data : null
    } catch {
        return null
    }
}
